import { render, staticRenderFns } from "./CollegeAdminRoles.vue?vue&type=template&id=c98499dc&scoped=true&"
import script from "./CollegeAdminRoles.vue?vue&type=script&lang=js&"
export * from "./CollegeAdminRoles.vue?vue&type=script&lang=js&"
import style0 from "./CollegeAdminRoles.vue?vue&type=style&index=0&id=c98499dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98499dc",
  null
  
)

export default component.exports